import * as React from "react"
import { connect } from "react-redux"

import ReduxToastr from "react-redux-toastr"
import { getUserRole, getUserSelectedSupplier } from "../../../core/reducers"
import { Roles } from "../../../utils"
import Loader from "../com_loader"

export interface ILoadingObject {
  isLoading: boolean
  message: string
}

export interface IOverlayProps {
  loading: ILoadingObject
  role: Roles
  selectedSupplier: string
}

const Overlay = ({ loading, role, selectedSupplier }: IOverlayProps) =>
  role === Roles.MARKET_LEADER && selectedSupplier === "UNDEFINED" ? (
    <div className="hide-whole-page">
      <h1>Vous n'avez actuellement aucun fournisseur attribué</h1>
      <p>
        Veuillez vous rendre sur le Portail Admin pour gérer la liste de vos
        fournisseurs
      </p>
    </div>
  ) : (
    <div>
      <ReduxToastr progressBar={true} />
      {loading.isLoading ? <Loader message={loading.message} /> : null}
    </div>
  )

const mapStateToProps = (state: any) => ({
  loading: state.loading,
  role: getUserRole(state),
  selectedSupplier: getUserSelectedSupplier(state)
})

export default connect<any, any, any, any>(
  mapStateToProps,
  null
)(Overlay)
